import { type ReactNode, lazy, Suspense } from 'react';
import type { SplitButtonOption } from '@/components/atoms/Button/SplitButtonWrapper';
import type { ButtonProps } from '@/components/atoms/Button/buttonProps';

const SplitButtonWrapper = lazy(
  () => import('@/components/atoms/Button/SplitButtonWrapper')
);

export type ButtonWrapperProps = {
  enabled: boolean;
  children: ReactNode;
  options: SplitButtonOption[] | undefined;
  ariaLabel: string;
} & Omit<ButtonProps, 'splitButton'>;

function ButtonWrapper({
  enabled,
  children,
  options,
  ariaLabel,
  ...restProps
}: ButtonWrapperProps) {
  return enabled && options ? (
    <Suspense fallback={children}>
      <SplitButtonWrapper
        options={options}
        ariaLabel={ariaLabel}
        {...restProps}
      >
        {children}
      </SplitButtonWrapper>
    </Suspense>
  ) : (
    children
  );
}

export default ButtonWrapper;
